import { render, staticRenderFns } from "./ModulesColors.vue?vue&type=template&id=04723544"
import script from "./ModulesColors.vue?vue&type=script&lang=js"
export * from "./ModulesColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports